export const ADD_REMINDER = 'ADD_REMINDER';

export const addReminder = (id, setRemindDate, toRemindDate, message, linkTo) => dispatch => {
  dispatch({
    type: ADD_REMINDER,
    id,
    setRemindDate,
    toRemindDate,
    message,
    linkTo,
  });
};



// WEBPACK FOOTER //
// ./src/actions/reminders.js